export function download(href, fileName) {
  let link = document.createElement('a');
  link.download = fileName;
  link.style.opacity = "0";
  link.href = href;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
